module.exports = __webpack_public_path__ + "img/circulo.6ec78969.svg";